import React from 'react';
import './Observations.scss'
import ObservationDetails from './ObservationDetails'

const Observations = (props) => {

    const { data } = props
    /** States */


    return (
        <div  className='observations' >
            {
                data.map((category, index) => {
                    return <ObservationDetails key={index} data={category} />
                })
                
            }
        </div>
    )

}

export default Observations;